'use strict';

import cookie from '../storage/cookie.js';

const getCfsShortlist = () => {
	const cookieData = cookie.getCookie(cookie.names.cfsShortlist);

	if (cookieData && cookieData.shortlist) {
		return cookieData.shortlist;
	}

	return [];
};

export default {
	addToCfsShortlist: (id) => {
		if (!id) {
			return;
		}

		let cookieData = cookie.getCookie(cookie.names.cfsShortlist) || {};
		const shortlist = getCfsShortlist();
		const index = shortlist.indexOf(id);

		if (index === -1) {
			shortlist.push(id);
			Object.assign(cookieData, { shortlist: shortlist });
			cookie.setCookie(cookie.names.cfsShortlist, cookieData);
		}
	},

	deleteFromCfsShortlist: (id) => {
		if (!id) {
			return;
		}

		let cookieData = cookie.getCookie(cookie.names.cfsShortlist) || {};
		const shortlist = getCfsShortlist();
		const index = shortlist.indexOf(id);

		if (index !== -1) {
			shortlist.splice(index, 1);
			Object.assign(cookieData, { shortlist: shortlist });
			cookie.setCookie(cookie.names.cfsShortlist, cookieData);
		}
	},

	getCfsShortlist,

	getCfsSortOrder: () => {
		const cookieData = cookie.getCookie(cookie.names.cfsPreferences);

		if (cookieData?.sortBy && cookieData?.sortOrder) {
			return {
				sortBy: cookieData.sortBy,
				sortOrder: cookieData.sortOrder
			};
		}

		return null;
	},

	getOwnedVehicleType: (vehicleType) => {
		const cookieData = cookie.getCookie(cookie.names.session);

		if (cookieData) {
			if (vehicleType === 'van') {
				return cookieData.ownedVan;
			}

			return cookieData.ownedCar;
		}

		return null;
	},

	getLocation: () => {
		const cookieData = cookie.getCookie(cookie.names.geoLocation);

		if (cookieData && cookieData.latLong) {
			return cookieData.latLong;
		}

		return null;
	},

	getPostcode: () => {
		const cookieData = cookie.getCookie(cookie.names.user);

		if (cookieData && cookieData.postcode) {
			const SPACE_REGEX = /\s+/gi;
			return cookieData.postcode.replace(SPACE_REGEX, '').toUpperCase();
		}

		return null;
	},

	setCfsSortOrder: (sortBy, sortOrder) => {
		let cookieData = cookie.getCookie(cookie.names.cfsPreferences) || {};
		
		Object.assign(cookieData, {
			sortBy: sortBy,
			sortOrder: sortOrder
		});

		cookie.setCookie(cookie.names.cfsPreferences, cookieData);
	},

	setLocation: (location) => {
		if (!location) {
			cookie.deleteCookie(cookie.names.geoLocation);
			return;
		}

		const cookieData = {
			latLong: location
		};
		cookie.setCookie(cookie.names.geoLocation, cookieData);
	},

	setPostcode: (postcode) => {
		let cookieData = cookie.getCookie(cookie.names.user) || {};

		Object.assign(cookieData, { postcode: postcode });
		cookie.setCookie(cookie.names.user, cookieData);
	}
};
